export function isURLTemplate(s) {
  return /(?=.*{z})(?=.*{x})(?=.*({y}|{-y}))/.test(s);
}
export function getURLFromTemplate(template, properties) {
  if (!template || !template.length) {
    throw new Error('url is not allowed to be empty');
  }

  var x = properties.x,
      y = properties.y,
      z = properties.z;

  if (Array.isArray(template)) {
    var index = Math.abs(x + y) % template.length;
    template = template[index];
  }

  return template.replace(/\{x\}/g, x.toString()).replace(/\{y\}/g, y.toString()).replace(/\{z\}/g, z.toString()).replace(/\{-y\}/g, (Math.pow(2, z) - y - 1).toString());
}
//# sourceMappingURL=tile-url.js.map